module.exports = __webpack_public_path__ + "img/42.4047589a.jpg";